/* eslint-disable max-statements */

interface IScriptIdentifier {
  url: string;
  defer: boolean;
}
const scriptLoader = (() => {
  const alreadyLoaded: { [key: string]: Promise<HTMLScriptElement> } = {};
  const load = (scriptObj: IScriptIdentifier) => {
    const { url, defer } = scriptObj;
    if (alreadyLoaded[url]) {
      return alreadyLoaded[url];
    }
    alreadyLoaded[url] = new Promise<HTMLScriptElement>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;

      if (defer) script.defer = defer;
      script.addEventListener(
        'load',
        () => {
          resolve(script);
        },
        false
      );
      script.addEventListener('error', () => reject(script), false);
      document.body.appendChild(script);
    });
    return alreadyLoaded[url];
  };

  return (scriptsObj: IScriptIdentifier | IScriptIdentifier[]) => {
    if (Array.isArray(scriptsObj)) {
      return Promise.all(scriptsObj.map(load));
    } else {
      return load(scriptsObj);
    }
  };
})();

export { IScriptIdentifier };
export default scriptLoader;
